import React, { useState } from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import { formatAmount } from "utils/Utils";
import { toCamelCase } from "utils/Utils";
import { parseDateMDY } from "utils/Utils";
import RepaymentInstallmentModal from "./RepaymentInstallmentModal/RepaymentInstallmentModal";

const RepaymentDetails = ({ classes, repaymentDetails }) => {
     const [showModal, setShowModal] = useState(false);
  const itemView = (label, value) => {
    return (
      <Grid item xs={12} sm={6} md={3} className={classes.fieldContainer}>
        <p style={{ marginBottom: 0 }}>
          <b>{label}</b>
        </p>
        <label>{value}</label>
      </Grid>
    );
  };
    const handleClose = () => {
      setShowModal(false);
    };
  return (
    <Grid container spacing={2}>
      {/* Title */}
      <Grid item xs={12} className={classes.inputFieldContainer}>
        <h2 className={classes.header} style={{ fontSize: "1.5rem" }}>
          Repayment Details
        </h2>
      </Grid>

      {/* Reference Details Lis(t */}
      <Grid item xs={12} container spacing={2} alignItems="center">
        <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
          <Grid container className={classes.inputFieldContainer} spacing={2}>
            {itemView("Installment Amount", formatAmount(repaymentDetails?.installmentAmount) || "NA")}
            {itemView("Interest Amount", formatAmount(repaymentDetails?.interestAmount) || "NA")}
            {itemView("Interest Calculation Type", toCamelCase(repaymentDetails?.interestCalculationType) || "NA")}
            {itemView("Interest Rate", Number(repaymentDetails?.interestRate)/360  || "NA")}
            {itemView("Product Type", toCamelCase(repaymentDetails?.productType) || "NA")}
            {itemView("Scheme Code", repaymentDetails?.schemeCode || "NA")}
            {itemView("Total Amount", formatAmount(repaymentDetails?.totalAmount) || "NA")}
            {itemView("Days Method", repaymentDetails?.daysMethod || "NA")}
            {itemView("Disbursal Date", parseDateMDY(repaymentDetails?.disbursalDate) || "NA")}
            {itemView("Repayment Schedule",  <a
              href
              onClick={() => setShowModal(!showModal)}
              style={{
                cursor: "pointer",
                textDecoration: "underline",
                display: "flex",
              }}
            >
              View
            </a> || "NA")}
          </Grid>
        </Grid>
      </Grid>
      {showModal && (
        <RepaymentInstallmentModal
          installmentData={repaymentDetails?.installments}
          showModal={showModal}
          closeModal={handleClose}
          classesChild={classes}
        />
      )}
    </Grid>
  );
};

RepaymentDetails.propTypes = {
  classes: PropTypes.object,
  repaymentDetails: PropTypes.object,
};

export default RepaymentDetails;
